export var SDK_VERSION = '6.17.3';
//# sourceMappingURL=version.js.map